
<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>
<template>
  <div class="mt-8 flex flex-col" v-if="load_data">
    <div class="table-first-container">
      <div class="table-second-container">
        <div class="table-third-container">
          <table class="table">
            <thead class="table-header">
              <tr>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.producer.name") }}
                </th>
                <th scope="col" class="table-header-cell">Rendimiento (Kg./ha)</th>
                <th scope="col" class="table-header-cell">Aceptado (Kg.)</th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr
                class="table-row"
                v-for="(provider, index) in providers"
                :key="index"
                >
                <td
                  class="table-cell link"
                  @click.prevent="goToShowProvider(provider)"
                  >
                  {{ provider.name }}
                </td>
                <td class="table-cell">{{ numberWithPrecision(provider.performance) }}</td>
                <td class="table-cell">{{ numberWithPrecision(provider.total_weight) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <loading-message v-else></loading-message>

  <table-paginator
    v-if="load_total"
    v-model="current_page"
    :total_rows="total_providers"
    :rows_per_page="rows_per_page"
    ></table-paginator>
</template>

<script>
  import TablePaginator from "@/components/views/layout/TablePaginator.vue";
  import Requester from "@/views/organization/requesters/production/query_by_provider/show_process.js";

  export default {
    name: "OrgProductionQueryProviderShowProcessDetails",
    data() {
      return {
        current_page: 1,
        total_providers: 10,
        rows_per_page: 12,
        providers: [],
        load_data: false,
        load_total: false
      };
    },
    props: {
      organization_id: { required: true },
      agro_exporter_process_id: { required: true }
    },

    components: { TablePaginator },

    created() {
      this.loadData();
    },
    methods: {
      goToShowProvider: function (provider) {
        this.$router.push({
          name: this.routeName("show_provider"),
          params: {
            organization_id: this.organization_id,
            agro_exporter_process_id: this.agro_exporter_process_id,
            provider_id: provider.id,
            provider_type: provider.type
          }
        });
      },

      fetchProviders: async function () {
        let response = await Requester.fetchProviders(
          this.organization_id,
          this.agro_exporter_process_id,
          this.current_page,
          this.rows_per_page
        );
        this.providers = response.data;
        this.load_data = true;
      },

      fetchTotalProviders: async function () {
        let response = await Requester.fetchTotalProviders(
          this.organization_id,
          this.agro_exporter_process_id
        );
        this.total_providers = response.data;
        this.load_total = true;
      },

      loadData: async function () {
        this.fetchTotalProviders();
        this.fetchProviders();
      }
    },

    watch: {
      current_page: async function () {
        this.load_data = false;
        await this.fetchProviders();
        this.load_data = true;
      }
    }
  };
</script>
